import React from "react";
import { Inbox, Plus, Search } from "lucide-react";
import { TID } from "@/lib/testIds";

export default function EmptyState({ hasAnyTasks, onAdd, search, statusFilter }) {
  const isSearchOrFilter =
    hasAnyTasks && (search.trim() !== "" || statusFilter !== "All");

  return (
    <div
      className="ab-card ab-shadow-sm px-6 py-12 flex flex-col items-center text-center"
      data-testid={TID.emptyState}
    >
      <div className="h-11 w-11 rounded-lg bg-[#F1F5F9] flex items-center justify-center mb-4">
        {isSearchOrFilter ? (
          <Search className="h-5 w-5 text-[#64748B]" />
        ) : (
          <Inbox className="h-5 w-5 text-[#64748B]" />
        )}
      </div>
      <h3 className="text-sm font-semibold text-[#0F172A]">
        {isSearchOrFilter ? "No matching compliances" : "No compliances yet"}
      </h3>
      <p className="mt-1 text-xs text-[#64748B] max-w-sm">
        {isSearchOrFilter
          ? "Try clearing your search or switching the filter to see more tasks."
          : "Add your first compliance obligation to start tracking due dates and documents."}
      </p>
      {!isSearchOrFilter && (
        <button
          type="button"
          onClick={onAdd}
          data-testid={TID.addFirstTask}
          className="mt-4 inline-flex items-center gap-2 rounded-md bg-[#0F172A] text-white h-9 px-3.5 text-sm font-medium hover:bg-[#1E293B]"
        >
          <Plus className="h-4 w-4" />
          Add compliance task
        </button>
      )}
    </div>
  );
}
